import React, { useState, useEffect } from 'react'
import { motion } from  'framer-motion'
import './About.scss'
import { urlFor, client } from '../../client'
import { AppWrap, MotionWrap } from '../../wrapper'



// const abouts = [
//   { title: "Backend Development", description: "I am a backend developer and i like to build beautiful and functional web applications.", imgUrl: images.about01 },
//   { title: "Frontend Development", description: "I am a frontend developer and i like to build beautiful web applications with beautiful GUI.", imgUrl: images.about02 },
//   { title: "API", description: "i develop/integrate API's (like REST, XML, JSON) for web apps with proper documentation.", imgUrl: images.about04 },
//   { title: "Web Security", description: "I try to make my apps as secure as possible although i am not the best at it.", imgUrl: images.about03 },
// ]

const About = () => {

  const [abouts, setAbouts] = useState ([])

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query)
      .then((data) => {
        setAbouts(data)
      })
  }, [])

  return (
    <>
      <h2 className="head-text">
        {/* I Know That <span>Good Code</span> <br /> means <span>Good Business</span> */}
        {/* Writing Good Code Is An <span>Art</span> <br /> And I Am Trying To Be The Best <span>Artist</span> */}
        About <span>Me</span>
      </h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition= {{ duration: 0.5, type: "tween"}}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  )
}

export default AppWrap(MotionWrap(About, 'app__about'), 'about', 'app__whitebg')



